"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchInput = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        borderBottom: "1px solid ".concat(theme.palette.grey[200]),
        padding: theme.spacing(0, 3, 4),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(0, 6, 4)
        },
        [".".concat(_mui.inputBaseClasses.input)]: {
            padding: theme.spacing(2, 3)
        },
        [".".concat(_mui.inputBaseClasses.root)]: {
            background: theme.palette.grey[100]
        }
    };
});
const SearchInput = exports.SearchInput = (0, _mui.styled)(_mui.TextField)((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        input: {
            cursor: 'pointer',
            '&::placeholder': {
                color: theme.palette.grey.A700
            }
        },
        [theme.breakpoints.up('md')]: {
            input: {
                cursor: 'text',
                height: 24
            }
        }
    };
});
